import axios from "axios";
import {
  IAuth,
  IBetApi,
  IConfigResponse,
  ICreateTicketResponse,
  IGetLandbaseToken,
} from "../interfaces/index";

import { getAxiosInstance } from "./axios";

export const ApiConsumer = {
  async getTokensForLandbase(
    baseURL: string,
    tempToken: string
  ): Promise<IGetLandbaseToken> {
    const response = await axios.post(
      `${baseURL}/Token/Panel?TempToken=${tempToken}`
    );
    return response.data;
  },
  async refreshAccessToken(): Promise<IAuth> {
    const response = await getAxiosInstance().get("Token/AccessToken");
    return response.data;
  },
  async getConfig(): Promise<IConfigResponse> {
    const response = await getAxiosInstance().get("api/Config");
    return response.data;
  },
  async getHistory(): Promise<IBetApi[]> {
    const response = await getAxiosInstance().get("api/ticket/History");
    return response.data;
  },
  async createTicket(ticket: IBetApi[]): Promise<ICreateTicketResponse> {
    const response = await getAxiosInstance().post("/api/bet", ticket);
    return response.data;
  },
  async createTicketPayout(ticketID: string): Promise<string> {
    const response = await getAxiosInstance().post("/api/bet/Payout", {
      ticketIdentification: ticketID,
    });
    return response.data;
  },
};
